import React from "react";
// import { Members } from "./../Home/Member/member";
import { AllMembers } from "./../Home/Member/All_Members";

//  International Committees

//  Local Committees



export const Supporting = () => {
  //    INTERNATIONAL COMMITTEES
  // const Name1 = [""];

  // const Info1 = [""];

  // const P_website1 = [""];

  // const Pic1 = [""];

  //   LOCAL COMMITTEES
  // const Name2 = [""];

  // const Info2 = [""]

  // const P_website2 = [""];

  // const Pic2 = [""];

  //   IHCI-2023 SUPPORT TEAM
  const Name3 = [
    "Surbi Jain"
  ];

  const Info3 = [
    "(Banasthali Vidyapith, Jaipur, India)"
  ];

  return (
    <section className="container">
      {/* <Members
        heading="INTERNATIONAL COMMITTEES"
        Name={Name1}
        Info={Info1}
        P_website={P_website1}
        Pic={Pic1}
      /> */}
      {/* <Members
        heading="LOCAL COMMITTEES"
        Name={Name2}
        Info={Info2}
        P_website={P_website2}
        Pic={Pic2}
      /> */}
      {/* <hr className="hr-style" /> */}
      <AllMembers heading="IHCI-2023 SUPPORT TEAM" Name={Name3} Info={Info3} />
      <hr className="hr-style" />
    </section>
  );
};
